import React, { LabelHTMLAttributes } from 'react';

import { Label } from './styles';

type PropTypes = React.HTMLAttributes<HTMLLabelElement> & LabelHTMLAttributes<void>;

const FieldLabel = ({ children, htmlFor, ...props }: PropTypes): JSX.Element => (
  <Label htmlFor={htmlFor} {...props}>
    {children}
  </Label>
);

export default FieldLabel;
